module.exports = __webpack_public_path__ + "img/若依家客厅.07015037.png";